import React, { useEffect, useState } from "react";
import "../Components/SelectDropdown.js";
import pozorista from "../Data/pozorista.json";
import muzeji from "../Data/muzeji.json";
import biblioteke from "../Data/biblioteke.json";
import bioskopi from "../Data/bioskopi.json";

const SearchInput = ({ func, isOpenAC }) => {
  const [value, setValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const data = [...pozorista, ...muzeji, ...biblioteke, ...bioskopi];

  const autoCompleteArray = data.map((value) => value.mesto);

  const filteredArray = autoCompleteArray.filter(
    (name, index, array) =>
      array.indexOf(name) === index && name.includes(value)
  );
  const sortedData = [...filteredArray].sort((a, b) =>
    a.localeCompare(b, "ru")
  );

  const setValueSearch = (event) => {
    const latinica = event.target.value;
    const cirilica = convertToCirilica(latinica);
    setValue(cirilica);
    setIsOpen(true);
  };

  const convertToCirilica = (latinicniTekst) => {
    const mapaKonverzije = {
      a: "а",
      b: "б",
      c: "ц",
      цц: "ч",
      цј: "ћ",
      d: "д",
      дј: "ђ",
      e: "е",
      f: "ф",
      g: "г",
      h: "х",
      i: "и",
      j: "ј",
      k: "к",
      l: "л",
      лј: "љ",
      m: "м",
      n: "н",
      нј: "њ",
      o: "о",
      p: "п",
      r: "р",
      s: "с",
      сс: "ш",
      t: "т",
      u: "у",
      v: "в",
      z: "з",
      дз: "џ",
      зз: "ж",
    };

    let cirilicniTekst = latinicniTekst.toLowerCase();

    for (const [slovo, cirilicnoSlovo] of Object.entries(mapaKonverzije)) {
      cirilicniTekst = cirilicniTekst.replace(
        new RegExp(slovo, "g"),
        cirilicnoSlovo
      );
    }

    return cirilicniTekst.toUpperCase();
  };

  const onForm = (e, city) => {
    e.preventDefault();
    if (city) {
      setValue(city);
      func(city);
    } else if (!city) {
      setValue("");
      func("");
    }
    setIsOpen(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onForm(e, value);
    }
  };

  useEffect(() => {}, [value]);

  return (
    <form className="search" onSubmit={(e) => onForm(e, value)}>
      <input
        type="text"
        placeholder="Претражите по граду... (нпр. НОВИ САД)"
        onChange={setValueSearch}
        onKeyPress={handleKeyPress}
        onClick={() => setIsOpen(true)}
        value={value}
      />
      {isOpen && (
        <ul
          className="auto-complete"
          style={{ display: isOpen || isOpenAC ? "block" : "none" }}
        >
          {sortedData.map((element) => {
            return (
              <li
                key={element}
                onClick={(e) => {
                  onForm(e, element);
                  setIsOpen(false);
                }}
              >
                {element}
              </li>
            );
          })}
        </ul>
      )}
      <i
        className="fa fa-search"
        aria-hidden="true"
        onClick={(e) => onForm(e, value)}
      ></i>
    </form>
  );
};

export default SearchInput;
